import { graphql } from "gql";

const USER_LIST_QUERY = graphql(`
  query UserList {
    userList {
      ...User
    }
  }
`);

export default USER_LIST_QUERY;
